export default __webpack_public_path__ + "static/media/bignosebug.345d2ff7.jpeg";